<template>
    <div class="pro-content flex flex-v flex-1">
        <div class="title">
            <el-row>
                <el-col :span="6" class="first">名称</el-col>
                <el-col :span="4">单价</el-col>
                <el-col :span="4">数量</el-col>
                <el-col :span="4">有效期至
                    <el-tooltip class="item" effect="dark" content="不输入日期为永久有效" placement="top">
                        <i class="el-icon-info" style="color: #cccccc"></i>
                    </el-tooltip>
                </el-col>
                <el-col :span="6">
                    <div class="opt-h">操作</div>
                </el-col>
            </el-row>
        </div>
        <div class="content flex-1" ref="pro_content" v-if="listData.length > 0">
            <el-row class="line" v-for="(item, i) in listData">
                <el-col :span="6" class="first">
                    <div class="pro-name">
                        {{item.title}}
                    </div>
                </el-col>
                <el-col :span="4">
                    {{item.price}}
                </el-col>
                <el-col :span="4">
                    <cash-text-input v-model="item.num" @change="resetTotalPrice(item)" />
                </el-col>
                <el-col :span="4">
                    <el-date-picker
                            v-model="item.expire_date"
                            type="date" :clearable="false" size="small"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            style="width: 130px;"
                            v-if="item.pro_type === 1"
                    />
                    <span v-else>&nbsp;</span>
                </el-col>
                <el-col :span="6">
                    <div class="opt-c">
                        <el-button type="text" size="mini" @click="deletePro(i)">删除</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="content flex-1" v-else>
            <div class="empty-box">
                暂无数据
            </div>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import TextInput from "@/model/TextInput";
    import CashTextInput from "@/model/Cash/CashTextInput";
    export default {
        name: "CashGiveProductList",
        components: {CashTextInput, TextInput},
        props: {
            content: {
                type: Array,
                default: []
            }
        },
        data: () => {
            return {
                listData: []
            };
        },
        mounted: function () {
            this.listData = this.content;
        },
        methods: {
            //清除单个项目
            deletePro: function (i) {
                this.$emit("deleteProduct", i);
            },
            //更新项目列表数据
            updateProductList: function () {
                this.$emit("updateProductList", this.listData);
            },
            //重新计算价格
            resetTotalPrice: function (item) {
                if(!obj.isEmpty(item.discount_data)){
                    if(item.discount_data.mode == 1)
                        item.total_price = item.price * item.num * item.discount_data.data / 10;
                    else
                        item.total_price = item.discount_data.data * item.num;
                }else
                    item.total_price = item.price * item.num;
                item.total_price = item.total_price.toFixed(2);
                this.updateProductList();
            },
        },
        watch: {
            content: function (data) {
                this.listData = data;
            },
            listData: function () {
                obj.unScrollbar(".content");
                this.$nextTick(() => {
                    obj.scrollbar(".content");
                });
            }
        }
    }
</script>

<style scoped>
    .pro-content .title {
        box-sizing: border-box;
        width: 100%;
        height: 50px;
        line-height: 50px;
        overflow: hidden;
        text-align: center;
        border-bottom: 1px solid #ebedf0;
        font-size: 14px;
        font-weight: bold;
        color: #909399;
        background-color: #f4f4f4;
    }
    .pro-content .content {
        overflow: hidden;
        text-align: center;
        padding-bottom: 16px;
    }
    .pro-content .content .line {
        line-height: 45px;
        /*padding: 5px 0;*/
        border-bottom: 1px solid #ebedf0;
        overflow:hidden;
    }
    .pro-content .content .line>.el-col>*{
        display: inline-block;
        vertical-align: middle;
    }
    .pro-content .content .line:hover{
        background-color: #F5F7FA;
    }
    .select_staff{
        border: none;
    }
    .first{
        padding-left: 30px;
        text-align: left;
    }
    .pro-name{
        line-height: 22px;
        padding: 11px 0px;
    }
    .opt-h,.opt-c{
        display: block !important;
        text-align: center;
        margin-right: 10px;
    }
    .opt-h{
        /*padding-right: 15px;*/
    }
    .empty-box{
        color: #999999;
        font-size: 14px;
        margin-top: 60px;
    }
</style>
